import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'activate',
    loadComponent: () =>
      import('./pages/activate/activate.page').then((m) => m.ActivatePage),
  },
  {
    path: 'resetpassword',
    loadComponent: () =>
      import('./pages/resetpassword/resetpassword.page').then((m) => m.ResetPasswordPage),
  },
  {
    path: 'home/subpages/invitations',
    loadComponent: () =>
      import('./pages/home/subpages/invitations/invitations.page').then((m) => m.InvitationsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/subpages/tools',
    loadComponent: () =>
      import('./pages/home/subpages/tools/tools.page').then((m) => m.ToolsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/subpages/results',
    loadComponent: () =>
      import('./pages/home/subpages/results/results.page').then((m) => m.ResultsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/subpages/settings',
    loadComponent: () =>
      import('./pages/home/subpages/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/subpages/shop',
    loadComponent: () =>
      import('./pages/home/subpages/shop/shop.page').then((m) => m.ShopPage),
    canActivate: [AuthGuard, roleGuard('shop')],
  },
  {
    path: 'home/subpages/invoices',
    loadComponent: () =>
      import('./pages/home/subpages/invoices/invoices.page').then((m) => m.InvoicesPage),
    canActivate: [AuthGuard, roleGuard('invoices')],
  },
  {
    path: 'home/subpages/invoice-preview',
    loadComponent: () =>
      import('./pages/home/subpages/invoice-preview/invoice-preview.page').then((m) => m.InvoicePreviewPage),
    canActivate: [AuthGuard, roleGuard('invoices')],
  },
  {
    // Messages with the support (XD F14 phase 3), reached from the FAQ window
    path: 'home/subpages/messages',
    loadComponent: () =>
      import('./pages/home/subpages/messages/messages.page').then((m) => m.MessagesPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/subpages/feedback',
    loadComponent: () => 
      import('./pages/home/subpages/feedback/feedback.page').then( m => m.FeedbackPage)
  },
  {
    // Super admin area (XD F14): overview, companies and users, release notes, feedback, audit log
    path: 'home/subpages/admin',
    loadComponent: () =>
      import('./pages/admin/admin-shell.page').then((m) => m.AdminShellPage),
    canActivate: [AuthGuard, roleGuard('superAdmin')],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/admin/admin-overview.page').then((m) => m.AdminOverviewPage),
      },
      {
        path: 'releases',
        loadComponent: () => import('./pages/admin/admin-releases.page').then((m) => m.AdminReleasesPage),
      },
      {
        path: 'feedback',
        loadComponent: () => import('./pages/admin/admin-feedback.page').then((m) => m.AdminFeedbackPage),
      },
      {
        path: 'feedback/:id',
        loadComponent: () => import('./pages/admin/admin-thread.page').then((m) => m.AdminThreadPage),
      },
      {
        path: 'companies',
        loadComponent: () => import('./pages/admin/admin-companies.page').then((m) => m.AdminCompaniesPage),
      },
      {
        path: 'companies/:id',
        loadComponent: () => import('./pages/admin/admin-company.page').then((m) => m.AdminCompanyPage),
      },
      {
        path: 'audit',
        loadComponent: () => import('./pages/admin/admin-audit.page').then((m) => m.AdminAuditPage),
      },
    ],
  },
  {
    path: 'icon-demo',
    loadComponent: () =>
      import('./pages/icon-demo/icon-demo.page').then((m) => m.IconDemoPage),
  },
  {
    path: 'home/subpages/api-test',
    loadComponent: () =>
      import('./pages/home/subpages/api-test/api-test.page').then((m) => m.ApiTestPage),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
